module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kaigyo-af7240c9c581b4a26e158a07e186f19a.png";